import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Param from '../store/param'
import Control from '../store/control'
import SideStyle from '../style/sideStyle'


export const ViewChanger = () => {
  const style = SideStyle()
  const activeStep = Param.Get('activeStep')
  const setup = Param.Get('setup')
  const prosthetics = Control.Get('prosthetics');
  const currentAngle = Control.Get('currentAngle')
  const SetCameraFree = Control.Get('SetCameraFree')
  const SetCameraLock = Control.Get('SetCameraLock')
  const SetCameraTop = Control.Get('SetCameraTop')
  const SetCameraBottom = Control.Get('SetCameraBottom')
  const SetCameraFront = Control.Get('SetCameraFront')
  const SetCameraBack = Control.Get('SetCameraBack')
  const SetCameraOut = Control.Get('SetCameraOut')
  const SetCameraIn = Control.Get('SetCameraIn')
  const flgOrbitEnable = Control.Get('flgOrbitEnable')

  const setFree = () => {
    SetCameraFree()
  }
  const setLock = () => {
    console.log('setLock')
    SetCameraLock()
    console.log('flgOrbitEnable', flgOrbitEnable)
  }
  const setOut = () => {
    const z = activeStep >= 10 ? -200 : 0
    if (prosthetics == 'AK') {
      SetCameraOut(0, z) // first augment is side of the leg and alwais is zero for AK.
    } else {
      SetCameraOut(setup.side, z)
    }
  }
  const setIn = () => {
    const z = activeStep >= 10 ? -200 : 0
    if (prosthetics == 'AK') {
      SetCameraIn(0, z) // first augment is side of the leg and alwais is zero for AK.
    } else {
      SetCameraIn(setup.side, z) 
    }
  }
  const setFront = () => {

    const z = activeStep >= 10 ? -200 : 0
    SetCameraFront(z)
    console.log('setFront')
    console.log('flgOrbitEnable', flgOrbitEnable)
  }
  const setBack = () => {
    const z = activeStep >= 10 ? -200 : 0
    SetCameraBack(z)
  }
  const setTop = () => {
    SetCameraTop()
  }
  const setBottom = () => {
    SetCameraBottom()
  }

  //angle ---> 1:Front 2:Back 3:Top 4:Bottom 5:Out 6:In
  function getActive(angle) {
    const retTrue = `${style.buttonView} ${style.buttonSelected}`
    const retFalse = style.buttonView
    //currentAngle ---> 1:Front 2:Back 3:Top 4:Bottom 5:Inside 6:Outside
    if (angle == 5) {
      if (prosthetics == 'AK') {
        if (setup.side == 1 && currentAngle == 6) return retTrue // right
        if (setup.side == 0 && currentAngle == 6) return retTrue // left
      } else {
        if (setup.side == 1 && currentAngle == 5) return retTrue // right
        if (setup.side == 0 && currentAngle == 6) return retTrue // left
      }
      return retFalse
    }
    if (angle == 6) {
      if (prosthetics == 'AK') {
        if (setup.side == 1 && currentAngle == 5) return retTrue // right
        if (setup.side == 0 && currentAngle == 5) return retTrue // left
      } else {
        if (setup.side == 1 && currentAngle == 6) return retTrue // right
        if (setup.side == 0 && currentAngle == 5) return retTrue // left
      }
      return retFalse
    }
    return currentAngle == angle ? retTrue : retFalse
  }

  return (
    <Grid container justifyContent='center' alignItems='center'  >
      {/*
      <Box className={style.moduleTitle}>View Changer</Box>
      */}

      {/*
          <Grid item xs={3}>
            <Grid container direction="row" spacing={1} alignItems='center' justifyContent="center">
              <Grid item xs={6}>
                <Button className={getActive(6)} onClick={setIn} size="small">Inside</Button>
              </Grid>
              <Grid item xs={6}>
                <Button className={getActive(5)} onClick={setOut} size="small">Outside</Button>
              </Grid>
            </Grid>
          </Grid>
          */}
      <Grid className={style.perspectiveBtns}>
        <Grid item xs={4} className={style.topBtns} >
          <span className={style.viewHead}>Side View</span>
          <Grid item className={style.ppBtn}>
            <Button className={getActive(5)} onClick={setOut} size='small'>
              Outside
            </Button>

            <Button fullWidth className={getActive(6)} onClick={setIn} size='small'>
              Inside
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={4} className={style.topBtns} >
          <span className={style.viewHead}>Front/Back View</span>
          <Grid item className={style.ppBtn}>
            <Button className={getActive(1)} onClick={setFront} size='small'>
              Front
            </Button>
            <Button className={getActive(2)} onClick={setBack} size='small'>
              Back
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={4} className={style.topBtns} >
          <span className={style.viewHead}>Horizontal View</span>
          <Grid item className={style.ppBtn}>
            <Button className={getActive(3)} onClick={setTop} size='small'>
              Top
            </Button>
            <Button className={getActive(4)} onClick={setBottom} size='small'>
              Bottom
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className={style.btnGrp}>
        <Button className={getActive(0)} onClick={setFree} size='small'>
          Free(Perspective)
        </Button>

        <Button className={getActive(7)} onClick={setLock} size='small'>
          Lock
        </Button>
      </Grid>
    </Grid>
  )
}

const SideViewChanger = () => {
  const type = Control.Get('type')

  switch (type) {
    case '':
      return null
    default:
      return <ViewChanger />
  }
}
export default SideViewChanger
